import { _ as r } from "../internals/export.js";
import { a } from "../internals/array-last-index-of.js";
r({
  target: "Array",
  proto: !0,
  forced: a !== [].lastIndexOf
}, {
  lastIndexOf: a
});